
const restaurantData = [
    { name: 'Redemption', address: '31 3rd St NE, Faribault, MN' },
    { name: 'Depot Bar and Grill', address: '311 Heritage Pl, Faribault, MN' },
    { name: 'Janna’s Market Grill', address: '129 Central Ave N, Faribault, MN' },
    { name: 'Faribault Family Restaurant', address: '2519 Lyndale Ave N, Faribault, MN' },
    { name: 'Crooked Pint', address: '125 1st Ave NE, Faribault, MN' },
    { name: 'Signature Bar and Grill', address: '201 Central Ave N #5212, Faribault, MN' },
    { name: 'Boonies Bar & Grill', address: '3301 Millersburg Blvd, Faribault, MN' },
    { name: 'Mizuki Fusion', address: '609 4th St NW, Faribault, MN' },
    { name: 'Joes Sports Café', address: '1510 7th St NW, Faribault, MN' },
    { name: 'Crack of Dawn Bake House', address: '09 Central Ave N, Faribault, MN' },
    { name: 'Taqueria El Jefe', address: '318 Central Ave N, Faribault, MN' },
    { name: 'Carbone’s Pizza', address: '1525 Division St W, Faribault, MN' },
    { name: 'Perkins', address: '333 Western Ave N, Faribault, MN' },
    { name: 'Our Place on Third', address: '20 3rd St NW, Faribault, MN' },
    { name: 'El Tequilla', address: '951 Faribault Rd, Faribault, MN' },
    { name: 'Twisted Chicken', address: '106 4th St NW, Faribault, MN' },
    { name: 'Basilleos Pizza', address: '108 4th St NW, Faribault, MN' },
    { name: 'Boxers', address: '429 Central Ave N, Faribault, MN' },
    { name: 'The Lodge on Lake Mazaska', address: '7170 153rd St W, Faribault, MN' },
    { name: 'Gran Plaza', address: '520 Central Ave N, Faribault, MN' },
    { name: '10,000 Drops/Corks & Pints', address: '28 4th St NE, Faribault, MN' },
    { name: 'A&W', address: '404 Wilson Ave NW, Faribault, MN' }
  ];
  
  export default restaurantData;
  